module.exports = __webpack_public_path__ + "static/media/9-1.025d357c.mp3";